<template>
  <div class="w-100 preview" style="padding: 20px 20px 0; background-color: #fff;">
    <div class="w-100" style="position: relative; left: -18px;">
    </div>
    <div ref="container" style="width: 100%; height: 100%;">
      <component :is="currentComponent" :changeComponent="changeComponent" :models="models" />
    </div>
  </div>
</template>

<script>
import preview1 from './components/preview1.vue'
import preview2 from './components/preview2.vue'
import StationUnit from './components/StationUnit'
import { deviceApi } from '@/api/station'
import { getDeviceGroup } from '@/api/device'

export default {
  name: 'PreviewGroup',
  data() {
    return {
      currentComponent: null,
      preview1,
      preview2,
      models: []
    }
  },
  async created() {
    try {
      const { data } = await getDeviceGroup(this.$route.query.id)
      this.stationName = data.name
      const t = data.extraProperty
      console.log(t);
      this.models = t.model || []

      if (t?.model?.includes('1')) {
        this.currentComponent = preview1
      } else {
        this.currentComponent = preview2
      }
    } catch(e) {
      console.log(e);
      this.currentComponent = preview2
    }
  },
  methods: {
    changeComponent(c) {
      if(c === 1) {
        this.currentComponent = preview1
      } else if (c === 2) {
        this.currentComponent = preview2
      } else {
        this.currentComponent = StationUnit
      }
    }
  }
}
</script>

<style scoped>
.preview {
  width: 100%;
  height: 100%;
}
.header {
  background: url('../../../assets/bg-dark.jpg') 0 0/cover no-repeat;
  overflow: hidden;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.header h1 {
  color: #fff;
  font-size: 20px;
  line-height: 40px;
}
</style>
